/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import feeApi from "../../api/Fees";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import FeeWrapper from "../../components/appWrapper/FeeWrapper";
import FeeCategoriesTable from "../../components/tables/primeTable/fees/FeeCategoriesTable";

const FeeCategories = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [feeCategories, setFeeCategories] = useState([]);
  const [feeCategoryModalVisibility, setFeeCategoryModalVisibility] = useState(false);
  const [selectedFeeCategoryDetail, setSelectedFeeCategoryDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [modalType, setModalType] = useState("update");
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    // fetch fee category
    try {
      listFeeCategories();

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let itemAdded = !empty(paramState.itemAdded)
          ? paramState.itemAdded
          : false;
        let itemUpdated = !empty(paramState.itemUpdated)
          ? paramState.itemUpdated
          : false;
        if (
          itemAdded === true ||
          itemUpdated === true 
        ) {
          const actionType = itemAdded
            ? "added"
            : itemUpdated
            ? "updated"
            : "";
          paramState.itemAdded = false;
          paramState.itemUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Fee Category ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                itemAdded: false,
                itemUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load fee categories. Please try again later."
      );
    }
  }, [ user?._id, rows, first, searchValue ]);

  // function to get all fee categories
  const listFeeCategories = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const page = first / rows;
      const response = await feeApi.getFeeCategories(page, rows, searchValue);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setFeeCategories([]);
      } else {
        setFeeCategories(response_data.response);
        setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete fee category
  const deleteFeeCategory = async () => {
    try {
      if (feeCategoryModalVisibility) setFeeCategoryModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const feeCategoryId =
        !empty(selectedFeeCategoryDetail) &&
        !empty(selectedFeeCategoryDetail._id)
          ? selectedFeeCategoryDetail._id
          : "";
      const response = await feeApi.deleteFeeCategory(feeCategoryId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete fee category";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Fee Category, ${
          !empty(selectedFeeCategoryDetail.title)
            ? selectedFeeCategoryDetail.title
            : ""
        }, was deleted successfully!`
      );
      return listFeeCategories();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideFeeCategoryModal = () => {
    setFeeCategoryModalVisibility(false);
  };

  //go to update fee category page
  const gotToUpdateFeeCategories = (data) => {
    const feeCategoryId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/fees/fee-category/${feeCategoryId}/update`);
  };

  // delete fee category
  const showDeleteFeeCategoriesModal = (data) => {
    setModalType("delete");
    setSelectedFeeCategoryDetail(data);
    setFeeCategoryModalVisibility(true);
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      setSearchValue(event.target.value);
      setFirst(0);
    }
  };

  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const feeCategoryModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideFeeCategoryModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => deleteFeeCategory()
        }
      />
    </div>
  );

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <>
      <FeeWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Fee Category"
              link="/fees/fee-category/add"
              title="Fee Categories"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <FeeCategoriesTable
                feeCategories={feeCategories}
                goToUpdateFeeCategoriesScreen={gotToUpdateFeeCategories}
                goToDeleteFeeCategoriesScreen={showDeleteFeeCategoriesModal}
                onPageChange={onPageChange}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onKeyDown={onKeyDown}
                onSearchChange={onSearchChange}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </FeeWrapper>

      <Dialog
        visible={feeCategoryModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={feeCategoryModalFooter}
        onHide={hideFeeCategoryModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "update" ? (
                !empty(selectedFeeCategoryDetail) &&
                !empty(selectedFeeCategoryDetail.active) &&
                selectedFeeCategoryDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected fee category -{" "}
              <strong>
                {!empty(selectedFeeCategoryDetail) &&
                !empty(selectedFeeCategoryDetail.title)
                  ? selectedFeeCategoryDetail.title
                  : ""}
              </strong>
              {selectedFeeCategoryDetail && (
                <b>
                  {!empty(selectedFeeCategoryDetail.name)
                    ? selectedFeeCategoryDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default FeeCategories;
